﻿package org.zq.pixelset.model

data class ImageSettings(
    val targetWidth: Int = 800,
    val targetHeight: Int = 600,
    val lockAspectRatio: Boolean = true,
    val selectedPresetIndex: Int = 2,
    val outputFormat: OutputFormat = OutputFormat.JPG,
    val quality: Float = 0.85f,
    val scaleMode: ScaleMode = ScaleMode.Fit,
    val processingMode: ProcessingMode = ProcessingMode.Resize,
    val rotationDegrees: Int = 0,
    val cropLeft: Float = 0f,
    val cropTop: Float = 0f,
    val cropRight: Float = 0f,
    val cropBottom: Float = 0f,
    val visualCrop: NormalizedRect = NormalizedRect(),
    val useVisualCrop: Boolean = false,
    val brightness: Int = 0,
    val contrast: Float = 1f,
    val saturation: Float = 1f,
) {
    fun toEditParams(): EditParams = EditParams(
        rotationDegrees = rotationDegrees,
        cropLeft = cropLeft,
        cropTop = cropTop,
        cropRight = cropRight,
        cropBottom = cropBottom,
        visualCrop = visualCrop,
        useVisualCrop = useVisualCrop,
        brightness = brightness,
        contrast = contrast,
        saturation = saturation,
    )
}

data class BatchProcessFailure(
    val imageName: String,
    val message: String,
)
